module.exports = __webpack_public_path__ + "6910af29198b470cd1a778b1dec02982.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folder_arrow_down_2x.png
// module id = 116
// module chunks = 0 1 2 3 4